
import Methods from "../methods";


const loadFilesByMonths = (context,payload) =>{

  const url =`report/filesByMonth/client/${payload.idClient}?${payload.params}`
  return Methods.doGet(context,url,null)

}

const loadBoxesByMonth = (context,payload) =>{
  const url =`report/boxesByMonth/client/${payload.idClient}?${payload.params}`
  return Methods.doPost(context,url,null)

}

const loadReportBoxesByMonthsPDF = (context, payload) =>{

  const url =`report/boxesByMonth/client/${payload.idClient}/pdf?${payload.params}`
  return Methods.doPostDonwload(context,url,{extExport: 'pdf'},`reporte-cajas`,null)

}

const loadReportBoxesByMonthsEXCEL = (context, payload) =>{

  const url =`report/boxesByMonth/client/${payload.idClient}/excel?${payload.params}`
  return Methods.doPostDonwload(context,url,{extExport: 'xlsx'},`reporte-cajas`,null)

}

const loadReportBoxesAreaByMonth = (context, payload) =>{
  const url =`report/boxesByMonthByArea/client/${payload.idClient}?${payload.params}`
  return Methods.doPost(context,url,null)
}

const loadReportBoxesAreaByMonthEXCEL = (context, payload) =>{

  const url =`report/boxesByMonthByArea/client/${payload.idClient}/excel?${payload.params}`
  return Methods.doPostDonwload(context,url,{extExport: 'xlsx'},`reporte-cajas-área`,null)

}

const loadReportBoxesAreaByMonthPDF = (context, payload) =>{

  const url =`report/boxesByMonthByArea/client/${payload.idClient}/pdf?${payload.params}`
  return Methods.doPostDonwload(context,url,{extExport: 'pdf'},`reporte-cajas-área`,null)

}


export default {
  loadFilesByMonths,
  loadBoxesByMonth,
  loadReportBoxesByMonthsPDF,
  loadReportBoxesByMonthsEXCEL,
  loadReportBoxesAreaByMonth,
  loadReportBoxesAreaByMonthEXCEL,
  loadReportBoxesAreaByMonthPDF
};






// WEBPACK FOOTER //
// ./src/api/modules/BoxesByMonthApi.js